import moment from "moment";
import { TourType } from "./model/TourType";
import { OrderStatus } from "./model/OrderStatus";
import { ExtraType } from "./model/ExtraType";

export const cleanTime = (i: string | Date): string => {
  const parsed = moment(i);
  return parsed.format("HH:mm");
};

export const numericDate = (i: string | Date): string => {
  const parsed = moment(i);
  return parsed.format("DD.MM.YYYY");
};

export const weekdayDayMonthDate = (i: string | Date): string => {
  const parsed = moment(i);
  return parsed.format("dddd DD. MMMM");
};

export const numberAsHour = (i: number): string => {
  const min = (i * 60) % 60;
  return `${Math.floor(i)}:${min}${min === 0 ? "0" : ""}`;
};

export const relativeLongMonthDate = (i: string | Date): string => {
  const parsed = moment(i);
  let s = parsed.format("DD. MMMM YYYY");
  if (parsed.isSame(moment(), "day")) {
    // today
    s = "Heute, " + s;
  } else if (parsed.isSame(moment().add(1, "day"), "day")) {
    // tomorrow
    s = "Morgen, " + s;
  }
  return s;
};

export const momentFromDateStringAndHour = (
  date: string,
  hour: number
): moment.Moment => {
  const m = moment(date);
  m.hours(hour);
  m.minutes((hour % 1) * 60);
  m.seconds(0);
  m.milliseconds(0);
  return m;
};

export const priceString = (price: number): string => {
  return (price / 100).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2
  });
};

export const displayStringForOrderStatus = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.Booked:
      return "Auftrag erstellt";
    case OrderStatus.CarrierAssigned:
      return "Frachtführer zugewiesen";
    case OrderStatus.InProgress:
      return "In Durchführung";
    case OrderStatus.WaitingForTourReview:
      return "Sendung zugestellt, Dokumente in Prüfung";
    case OrderStatus.ReadyToInvoice:
      return "Abgeschlossen";
    case OrderStatus.Invoiced:
      return "Abgeschlossen";
    case OrderStatus.Cancelled:
      return "Storniert";
    default:
      return status;
  }
};

export const displayStringForTourType = (type: TourType): string => {
  switch (type) {
    case "DIRECT":
      return "Direktfahrt";
    case "COLLECTION":
      return "Sammelfahrt";
    case "DISTRIBUTION":
      return "Verteilerfahrt";
    default:
      return type;
  }
};

export const displayStringForExtraType = (type: ExtraType): string => {
  switch (type) {
    case ExtraType.Liftgate:
      return "Ladebordwand";
    case ExtraType.Sideloading:
      return "seitenbeladbar";
    case ExtraType.RampLoadable:
      return "rampenfähig";
    case ExtraType.Forklift:
      return "Hubwagen";
    case ExtraType.RigidBox:
      return "Koffer";
    case ExtraType.PalletExchange:
      return "Palettentausch";
    case ExtraType.TwoManHandling:
      return "Zwei-Mann-Handling";
    case ExtraType.Discount:
      return "Rabattierung";
    case ExtraType.NeutralVehicle:
      return "Neutrales Fahrzeug";
    case ExtraType.Cancellation:
      return "Stornierung";
    case ExtraType.Weekend:
      return "Wochenende";
    case ExtraType.WaitingTime:
      return "Wartezeit";
    case ExtraType.Manual:
      return "Manuell";
    case ExtraType.LargeWindowDiscount:
      return "Rabattierung große Zeitfenster";
    default:
      return type;
  }
};
